import {Accordion, Checkbox} from 'components';
import React from 'react';

function Permission({permission, disabled = false, ...rest}) {
  return (
    <div
      className={`flex items-center ${disabled ? 'cursor-not-allowed' : ''}`}
    >
      <Checkbox noLeftPadding {...rest} disabled={disabled} />
      <span
        title={permission}
        className={`text-sm truncated-text
      ${disabled ? 'text-grey30' : 'text-body'}
      `}
      >
        {permission}
      </span>
    </div>
  );
}

function ProfiledRiskRoles({
  allProfiledRiskPermissions,
  // toggleProfiledRiskPermissions,
  profiledRiskPermissions = {},
  eventsGroup,
  manageFlowsGroup,
  casesGroup,
  changeProfiledRiskPermissions,
  toggleEventsGroup,
  toggleManageFlowsGroup,
  toggleCasesGroup,
  billingPermissions = {},
  changeBillingPermissions,
  customListPermissions = {},
  changeCustomListPermissions,
  developerPermissions = {},
  changeDeveloperPermissions,
  allBillingPermissions,
  allCustomListPermissions,
  allDeveloperPermissions,
  toggleAllProfiledRiskPagePermissions,
}) {
  return (
    <div className="mt-8">
      <div className="flex items-center">
        <Checkbox
          noLeftPadding
          isChecked={
            allProfiledRiskPermissions &&
            allBillingPermissions &&
            allCustomListPermissions &&
            allDeveloperPermissions
          }
          onChange={toggleAllProfiledRiskPagePermissions}
        />
        <span className="text-sm text-body">All Permissions</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-start gap-4 mt-4">
        <div className="flex flex-col gap-4">
          <div className="rounded p-4 bg-white">
            <Permission
              permission="Overview"
              isChecked={profiledRiskPermissions?.overview}
              onChange={() => changeProfiledRiskPermissions('overview')}
            />
          </div>

          <Accordion
            title={
              <div className="flex items-center">
                <Checkbox
                  noLeftPadding
                  isChecked={eventsGroup}
                  onChange={() => toggleEventsGroup()}
                />
                <span className="text-sm font-medium text-body">Events</span>
              </div>
            }
          >
            <div className="flex flex-col py-4 mt-2 gap-4">
              <Permission
                permission="View Event Details"
                isChecked={profiledRiskPermissions?.viewEventDetails}
                onChange={() =>
                  changeProfiledRiskPermissions('viewEventDetails')
                }
              />
            </div>
          </Accordion>

          <div className="rounded p-4 bg-white">
            <Permission
              permission="Reports"
              isChecked={profiledRiskPermissions?.reports}
              onChange={() => changeProfiledRiskPermissions('reports')}
            />
          </div>

          <div className="rounded p-4 bg-white">
            <Permission
              permission="Configuration"
              isChecked={profiledRiskPermissions?.configuration}
              onChange={() => changeProfiledRiskPermissions('configuration')}
            />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <div className="rounded p-4 bg-white">
            <Permission
              permission="Profiles"
              isChecked={profiledRiskPermissions?.profiles}
              onChange={() => changeProfiledRiskPermissions('profiles')}
            />
          </div>

          <Accordion
            title={
              <div className="flex items-center">
                <Checkbox
                  noLeftPadding
                  isChecked={manageFlowsGroup}
                  onChange={() => toggleManageFlowsGroup()}
                />
                <span className="text-sm font-medium text-body">
                  Manage flows
                </span>
              </div>
            }
          >
            <div className="flex flex-col py-4 mt-2 gap-4">
              <Permission
                permission="Create Flow"
                isChecked={profiledRiskPermissions?.createFlows}
                onChange={() => changeProfiledRiskPermissions('createFlows')}
              />
              <Permission
                permission="Delete Flow"
                isChecked={profiledRiskPermissions?.deleteFlows}
                onChange={() => changeProfiledRiskPermissions('deleteFlows')}
              />
              <Permission
                permission="Manage Decision"
                isChecked={profiledRiskPermissions?.manageDecision}
                onChange={() => changeProfiledRiskPermissions('manageDecision')}
              />
              <Permission
                permission="Manage Rules"
                isChecked={profiledRiskPermissions?.manageRules}
                onChange={() => changeProfiledRiskPermissions('manageRules')}
              />
              <Permission
                permission="View Cases"
                isChecked={profiledRiskPermissions?.viewCases}
                onChange={() => changeProfiledRiskPermissions('viewCases')}
              />
              <Permission
                permission="View Events"
                isChecked={profiledRiskPermissions?.viewEvents}
                onChange={() => changeProfiledRiskPermissions('viewEvents')}
              />
              <Permission
                permission="Access Flow settings"
                isChecked={profiledRiskPermissions?.accessFlowSettings}
                onChange={() =>
                  changeProfiledRiskPermissions('accessFlowSettings')
                }
              />
            </div>
          </Accordion>

          <div className="rounded p-4 bg-white">
            <Permission
              permission="Billing"
              isChecked={billingPermissions?.viewHistory}
              onChange={() => changeBillingPermissions('viewHistory')}
            />
          </div>

          <div className="rounded p-4 bg-white">
            <Permission
              permission="Profile Information"
              isChecked={profiledRiskPermissions?.profileInformation}
              onChange={() =>
                changeProfiledRiskPermissions('profileInformation')
              }
            />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <Accordion
            title={
              <div className="flex items-center">
                <Checkbox
                  noLeftPadding
                  isChecked={casesGroup}
                  onChange={() => toggleCasesGroup()}
                />
                <span className="text-sm font-medium text-body">Cases</span>
              </div>
            }
          >
            <div className="flex flex-col py-4 mt-2 gap-4">
              <Permission
                permission="Review Cases"
                isChecked={profiledRiskPermissions?.reviewCases}
                onChange={() => changeProfiledRiskPermissions('reviewCases')}
              />
              <Permission
                permission="Download Reports"
                isChecked={profiledRiskPermissions?.downloadReports}
                onChange={() =>
                  changeProfiledRiskPermissions('downloadReports')
                }
              />
            </div>
          </Accordion>

          <div className="rounded p-4 bg-white">
            <Permission
              permission="Custom list"
              isChecked={customListPermissions?.viewCustomList}
              onChange={() => changeCustomListPermissions('viewCustomList')}
            />
          </div>

          <div className="rounded p-4 bg-white">
            <Permission
              permission="Developers"
              isChecked={developerPermissions?.manageApps}
              onChange={() => changeDeveloperPermissions('manageApps')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfiledRiskRoles;
